/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useGetVideosList } from "../apis";

const useVideosList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    videosList,
    meta,
    isLoading,
    refetch: refetchVideos
  } = useGetVideosList(requestParams);

  return {
    videosList,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchVideos
  };
};

export default useVideosList;
